import { deleteApiWithData, getApi } from 'apis';
import { SideDrawerWrapper } from 'components/Global';
import useDebounce from 'components/Global/Hooks/UseDebounce';
import ConfirmDelete from 'components/Global/confirmDeleteModel';
import { TablePagination, TableSorter } from 'interfaces/global.interface';
import { useEffect, useState } from 'react';
import { toastText } from 'utils/utils';
import AddBranchCodeBody from './AddBranchCodeBody';
import BranchCodeTable from './Table/BranchCodeTable';
import BranchCodeHeader from './Table/Header';
import styles from './index.module.scss';

const BranchCodeComponent = () => {
	const [searchValue, setSearchValue] = useState('');
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [totalRecords, setTotalRecords] = useState(0);
	const [sortField, setSortField] = useState('');
	const [sortOrder, setSortOrder] = useState('');
	const [drawerAnimation, setDrawerAnimation] = useState<boolean>(false);
	const [isDeleteLoading, setIsDeleteLoading] = useState<boolean>(false);
	const [isSideDrawerOpen, setIsSideDrawerOpen] = useState<boolean>(false);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [edit, setEdit] = useState<any>();
	const [isLoading, setIsLoading] = useState(false);
	const [drawerInfo, setDrawerInfo] = useState({
		drawerTitle: 'Branch Code',
	});
	const [branchData, setBranchData] = useState([]);
	const [calculationMethod, setCalculationMethod] = useState<
		'BRANCH_WISE' | 'COMPANY_WISE'
	>('COMPANY_WISE');

	const debouncedSearchValue = useDebounce(searchValue, 500);

	const buttons = [
		{
			text: 'Add Branch Code',
			isLoading: false,
			className: 'btn-blue',
			// icon: <AddSvg />,
			isSubmit: true,
			onclick: () => {
				openDrawerHandler();
			},
			disabled: isLoading,
		},
	];

	const handleSearchApi = async (value: string) => {
		//search api
	};

	const handleSearch = (value: string) => {
		setSearchValue(value);
		setCurrentPage(1);
	};

	const tableChangeHandler = (
		pagination: TablePagination,
		filters: any,
		sorter: TableSorter
	) => {
		setTotalRecords(pagination.total);
		setCurrentPage(pagination.current);
		setPageSize(pagination.pageSize);
		let order = '';
		if (sorter?.order === 'ascend') {
			order = 'asc';
		} else if (sorter?.order) {
			order = 'desc';
		}
		setSortOrder(order);
		setSortField(sorter.field);
	};

	// Open side drawer with animation
	const openDrawerHandler = () => {
		setDrawerInfo({ drawerTitle: 'Add Branch Code' });
		setDrawerAnimation(true);
		setIsSideDrawerOpen(true);
	};
	// Remove the side drawer
	const removeDrawerFromDom = () => {
		setIsSideDrawerOpen(false);
	};

	// Close the side drawer with animation
	const closeDrawerByAnimation = () => {
		setEdit(null); //!isAddUserLoading &&
		setDrawerAnimation(false); //!isAddUserLoading &&
	};

	const fetchBranchCodes = async () => {
		try {
			setIsLoading(true);

			const query = {
				page: currentPage,
				search: debouncedSearchValue.trim(),
				// search: searchValue,
				sortBy: sortField,
				sortOrder: sortOrder,
				pageSize: pageSize,
			};

			const users = await getApi('/branchCode', query);

			setCalculationMethod(users.data.calculationMethod);
			setBranchData(users.data.data);
			setTotalRecords(users.data.total);
		} catch (err: any) {
			const errorMessage =
				err?.response?.data?.message ||
				'Something went wrong in fetching branches';
			toastText(errorMessage, 'error');
		} finally {
			setIsLoading(false);
		}
	};
	// Change data and title between components
	const setDrawerInfoHandler = (drawerTitle: any) => {
		setDrawerInfo({ drawerTitle });
	};

	// Confirm operation
	const handleOk = () => {
		setIsModalOpen(false);
		setEdit(null);
	};

	// Cancel operation
	const handleCancel = () => {
		setIsModalOpen(false); // !isAddUserLoading &&
		setEdit(null);
	};

	const showModal = () => {
		setIsModalOpen(true);
	};

	// Delete user
	const deleteHandler = async () => {
		if (edit) {
			try {
				setIsDeleteLoading(true);
				const response = await deleteApiWithData('/branchCode', {
					branchCodeId: edit.id,
				});
				if (totalRecords > 1 && totalRecords % pageSize === 1) {
					setCurrentPage(currentPage - 1);
				}
				handleCancel();
				fetchBranchCodes();
				let message =
					response?.data?.message ||
					'Branch code deleted successfully';

				toastText(message, 'success');
			} catch (error: any) {
				const errorMessage =
					error.response?.data?.message ||
					'Something went wrong in delete branch code';
				toastText(errorMessage, 'error');
			} finally {
				setIsDeleteLoading(false);
			}
		}
	};

	useEffect(() => {
		fetchBranchCodes();
	}, [pageSize, debouncedSearchValue, currentPage, sortOrder, sortField]);
	return (
		<div>
			{/* <TableActionHeader title={'Branch Code'}>
				<div>
					<Buttons buttons={buttons} />
				</div>
			</TableActionHeader> */}
			<div className={styles['employee-container']}>
				<BranchCodeHeader
					searchValue={searchValue}
					handleSearch={handleSearch}
					handleSearchApi={handleSearchApi}
					button={buttons}
				/>
				<BranchCodeTable
					branchData={branchData}
					totalRecords={totalRecords}
					pageSize={pageSize}
					currentPage={currentPage}
					tableChangeHandler={tableChangeHandler}
					fetchRecords={fetchBranchCodes}
					setEditData={setEdit}
					openDrawerHandler={openDrawerHandler}
					setDrawerInfoHandler={setDrawerInfoHandler}
					showModal={showModal}
					isLoading={isLoading}
					calculationMethod={calculationMethod}
				/>
			</div>
			{isSideDrawerOpen && (
				<SideDrawerWrapper
					isOpen={drawerAnimation}
					removeDrawerFromDom={removeDrawerFromDom}
					closeDrawerByAnimation={closeDrawerByAnimation}
					headerTitle={drawerInfo.drawerTitle}
					position="right"
					width="half"
				>
					<AddBranchCodeBody
						closeDrawerByAnimation={closeDrawerByAnimation}
						fetchBranchCodes={fetchBranchCodes}
						editSelected={edit}
						setEditSelectedUser={setEdit}
						calculationMethod={calculationMethod}
					/>
				</SideDrawerWrapper>
			)}
			<ConfirmDelete
				handleCancel={handleCancel}
				handleOk={handleOk}
				isModalOpen={isModalOpen}
				deleteHandler={deleteHandler}
				isLoading={isDeleteLoading} //isLoading

				// isAddUserLoading={false} //isAddUserLoading
			/>
		</div>
	);
};

export default BranchCodeComponent;
